$('#hide-global-message').on('click', function (e) {
    $('#global-message').hide();
    window.sessionStorage.setItem('hide-global-message', 'true');
    hideGlobalMessage = true;
});

$(function () {
    const hideMessage = window.sessionStorage.getItem('hide-global-message');

    if (hideMessage && hideMessage === 'true') {
        hideGlobalMessage = true;
        $('#global-message').hide();
    } else {
        hideGlobalMessage = false;
        $('#global-message').show();
    }
});

let hideGlobalMessage = false;


